import { get, post, put } from '../Services/http';
import { catchError } from './Error.action';
import { show as showNotification, errorShow as showError } from './Notification.action';
import { addToCart, gtmShowCart } from './../Services/Gtm.service';

export const CART_LOAD = 'CART_LOAD';
export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_RECEIVE = 'CART_RECEIVE';
export const CART_SHOW_INFO = 'CART_SHOW_INFO';
export const CART_HIDE = 'CART_HIDE';

export const load = () => (dispatch, getState) => {
    return get('/api/cart')
        .then(response => response.json())
        .then(cart => dispatch(receive(cart)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
        ;
}

export const loadError = error => ({
    type: CART_LOAD_ERROR,
    payload: {
        error,
    }
})

export const receive = cart => ({
    type: CART_RECEIVE,
    payload: cart,
})

export const toggle = () => (dispatch, getState) => {
    if (!getState().cart.showInfo) {
        gtmShowCart(getState().cart);
    }
    dispatch(show(!getState().cart.showInfo));
}

const show = visible => ({
    type: CART_SHOW_INFO,
    payload: {
        showInfo: visible,
    }
})

export const add = ({ articleNumber, quantity = 1, nodeIdToShowNotification = null, notificationMessage = null, hash = '' }) => {
    return (dispatch) => {
        if (!quantity || isNaN(quantity) || parseInt(quantity) <= 0) {
            return;
        }

        return post('/api/cart/add', { articleNumber, quantity: parseInt(quantity) })
            .then(response => response.json())
            .then(cart => {
                const nodeIdToShowError = "error-" + articleNumber;
                dispatch(receive(cart));
                let formattedArticleNumber = articleNumber[0].toLowerCase() + articleNumber.toUpperCase().slice(1);
                nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
                if (cart.errors[articleNumber] != null) {
                    dispatch(showError(nodeIdToShowNotification, cart.errors[articleNumber], hash));
                }
                else if (cart.errors[formattedArticleNumber] != null) {
                    dispatch(showError(nodeIdToShowNotification, cart.errors[formattedArticleNumber], hash));
                }
                else if (cart.errors[articleNumber.toLowerCase()] != null) {
                    dispatch(showError(nodeIdToShowNotification, cart.errors[articleNumber.toLowerCase()], hash));
                } else {
                    const product = cart.orderRows.find(p => p.articleNumber == articleNumber);
                    if (product && product.gtmEcommerceItem) {
                        product.gtmEcommerceItem.quantity = parseInt(quantity);
                        addToCart([product.gtmEcommerceItem]);
                    }
                }
            })
            .catch(ex =>
                dispatch(catchError(ex, error =>
                    loadError(error))));
    }
}

export const addMultiple = (items) => {
    return (dispatch) => {
        if (items.length <= 0) {
            return;
        }

        return post('/api/cart/addMultiple', { Items: items })
            .then(response => response.json())
            .then(cart => {
                let hash = Date.now();
                dispatch(receive(cart));
                let gtmItems = [];
                items.map((item) => {
                    let formattedArticleNumber = item.articleNumber[0].toLowerCase() + item.articleNumber.toUpperCase().slice(1);
                    if (cart.errors[item.articleNumber] != null) {
                        dispatch(showError(item.articleNumber, cart.errors[item.articleNumber], hash));
                    }
                    else if (cart.errors[formattedArticleNumber] != null) {
                        dispatch(showError(item.articleNumber, cart.errors[formattedArticleNumber], hash));
                    }
                    else if (cart.errors[item.articleNumber.toLowerCase()] != null) {
                        dispatch(showError(item.articleNumber, cart.errors[item.articleNumber.toLowerCase()], hash));
                    }
                    else {
                        const product = cart.orderRows.find(p => p.articleNumber == item.articleNumber);
                        if (product && product.gtmEcommerceItem) {
                            product.gtmEcommerceItem.quantity = parseInt(item.quantity);
                            gtmItems.push(product.gtmEcommerceItem);
                        }
                    }
                });
                if (gtmItems.length > 0) {
                    gtmItems.map((v, i) => v.index = i);
                    addToCart(gtmItems);
                }
            })
            .catch(ex =>
                dispatch(catchError(ex, error =>
                    loadError(error))));
    }
}

export const reorder = ({ orderId, nodeIdToShowNotification = null, notificationMessage = null, hash = '' }) => {
    if (orderId) {
        return (dispatch) => {
            return post('/api/cart/reorder', { orderId })
                .then(response => response.json())
                .then(cart => {
                    dispatch(receive(cart));
                    nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
                })
                .catch(ex => dispatch(catchError(ex, error => loadError(error))))
                ;
        }
    }
}

export const update = (rowSystemId, quantity, articleNumber) => (dispatch) => {
    return put(`/api/cart/update`, { rowSystemId, quantity, articleNumber })
        .then(response => response.json())
        .then(cart => {
            let hash = Date.now();
            dispatch(receive(cart));
            let formattedArticleNumber = articleNumber[0].toLowerCase() + articleNumber.toUpperCase().slice(1);
            if (cart.errors[articleNumber] != null) {
                dispatch(showError(articleNumber, cart.errors[articleNumber], hash));
            }
            else if (cart.errors[formattedArticleNumber] != null) {
                dispatch(showError(articleNumber, cart.errors[formattedArticleNumber], hash));
            }
            else if (cart.errors[articleNumber.toLowerCase()] != null) {
                dispatch(showError(articleNumber, cart.errors[articleNumber.toLowerCase()], hash));
            }
        })
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
        ;
}